// Normalize any phone-like string into a WhatsApp-compatible international number
// (digits only, country code prefix, no leading zero).
//
// Rules:
//   "+31 6 4826 1160"  -> "31648261160"
//   "0031648261160"    -> "31648261160"
//   "0648261160"       -> "31648261160"  (assume NL when starts with single 0)
//   "31648261160"      -> "31648261160"
//   ""                 -> ""
export function normalizeWhatsAppNumber(raw, defaultCountryCode = "31") {
  if (!raw) return "";
  let n = String(raw).replace(/\D/g, "");
  if (!n) return "";
  if (n.startsWith("00")) return n.slice(2);       // "0031..." -> "31..."
  if (n.startsWith("0")) return defaultCountryCode + n.slice(1);  // NL local "06..." -> "316..."
  return n;
}

export function whatsappHref(raw) {
  const n = normalizeWhatsAppNumber(raw);
  return n ? `https://wa.me/${n}` : null;
}
